// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N5m2","icon":"styles_icon__6zhhE"};